import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'

// Shared destructive-action confirmation dialog.
// If onConfirm returns a promise, the button shows a spinner until it settles.
const ConfirmModal = ({
  show,
  onClose,
  onConfirm,
  title = 'Are you sure?',
  message,
  confirmLabel = 'Delete',
  cancelLabel = 'Cancel',
  variant = 'danger',
  icon = 'trash-outline'
}) => {
  const [busy, setBusy] = useState(false)

  const handleConfirm = async () => {
    if (!onConfirm) return
    try {
      setBusy(true)
      await onConfirm()
    } finally {
      setBusy(false)
    }
  }

  return (
    <Modal
      show={show}
      onHide={busy ? () => {} : onClose}
      centered
      size="sm"
      aria-labelledby="confirm-modal-title"
      aria-describedby="confirm-modal-message"
      className="bl-confirm"
    >
      <Modal.Body className="text-center pt-4">
        <div className={`bl-confirm__icon bl-confirm__icon--${variant}`} aria-hidden="true">
          <ion-icon name={icon}></ion-icon>
        </div>
        <h2 className="h3 mb-2" id="confirm-modal-title">{title}</h2>
        {message && (
          <p className="text-muted mb-0" id="confirm-modal-message">{message}</p>
        )}
      </Modal.Body>
      <Modal.Footer className="bl-confirm__footer">
        <button type="button" className="btn btn-secondary" onClick={onClose} disabled={busy}>
          {cancelLabel}
        </button>
        <button
          type="button"
          className={`btn btn-${variant}`}
          onClick={handleConfirm}
          disabled={busy}
          autoFocus
        >
          {busy && <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>}
          {confirmLabel}
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default ConfirmModal
